import { combineReducers } from 'redux'
import { reducer as allDemandes } from './getAllDemandes'
import { reducer as archive } from './getArchive'
import { reducer as demande } from './getDemande'
import { reducer as addDemande } from './addDemande'
import { reducer as editDemande } from './editDemande'
import { reducer as deleteDemande } from './deleteDemande'
import { reducer as verifCertif } from './verifCertif'
import { reducer as transfert } from './transfert'
import { reducer as updatePay } from './updatePay'

export default combineReducers({
    allDemandes,
    archive,
    demande,
    addDemande,
    editDemande,
    deleteDemande,
    verifCertif,
    transfert,
    updatePay,
})
